import { useNavigate } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import { Brand } from "@/components/Brand";
import { ModeSwitcher } from "@/components/ModeSwitcher";
import { NotificationBell } from "@/components/NotificationBell";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function TopBar({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="glass fixed left-3 right-3 top-3 z-40 flex items-center justify-between rounded-2xl px-3 py-2 md:left-6 md:right-6 md:top-5">
      <Brand to="/" />
      <div className="flex items-center gap-2">
        <ModeSwitcher />
        {children}
        <NotificationBell />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button data-testid="user-menu-button" className="grid h-10 w-10 place-items-center rounded-full bg-primary text-sm font-bold text-primary-foreground shadow-[0_0_14px_hsl(var(--primary)/0.5)] transition-transform hover:-translate-y-0.5">
              {user?.name?.[0]?.toUpperCase() || <User className="h-4 w-4" />}
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            <DropdownMenuLabel>
              <p className="font-semibold" data-testid="user-menu-name">{user?.name}</p>
              <p className="text-xs font-normal text-muted-foreground">{user?.email}</p>
              <p className="mt-1 text-xs font-medium capitalize text-primary" data-testid="user-menu-role">{user?.admin_level ? `${user.admin_level.replace("_", " ")} · ` : ""}{user?.account_type}</p>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onLogout} data-testid="logout-button">
              <LogOut className="mr-2 h-4 w-4" /> Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
